<template>
  <ComboPicker
    :label="label"
    :orientation="orientation"
    strings="marca/modelo;a"
    icon="mdi-star-four-points"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="orientation == 'horizontal' ? 'Todas as marcas/modelo' : '(Todas)'"
    types="grouped-items"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'
import { BrandModel } from '@/models'
import { orderBy } from 'oderon-commons/src/utils'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Marca/Modelo' },
    orientation: { type: String, default: 'horizontal' },
    value: {}
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: []
    }
  },
  methods: {
    async fetchData() {
      let rows = await BrandModel.findAll()
      rows = rows.map(r => ({id: r.id, name: r.name}))
      this.allItems = orderBy(rows, [['name', 'asc']])
    }
  }
}

</script>

<style>

</style>